var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-progress-bar"},_vm._l((_vm.steps),function(n){return _c('div',{staticClass:"c-progress-bar__step",class:{
      'c-progress-bar__step--active': n <= _vm.current,
      'c-progress-bar__step--short': _vm.short,
    }},[(_vm.current === n)?_c('div',{staticClass:"c-progress-bar__copy lg:visible"},[_vm._t("default")],2):_vm._e()])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }